import React from 'react';
import { Button, Space } from 'antd';
import get from 'lodash/get';
import { DownOutlined, MailOutlined, PhoneOutlined, UpOutlined } from '@ant-design/icons';
import classNames from 'classnames';

import LeadName from '@/components/Lead/LeadName';
import Card from '@/components/Card';
import { F } from '@/utils/intl';


import styles from './CustomerDetailHeader.less';
import { CustomerModel } from '@/typings/models/Customer';
import { CUSTOMER_DETAILS_VISIBLE_PROPERTIES } from './constants';
import { CustomerCardOrderedProperties } from './CutomerProperties';
import CustomerPreferencesList from './CusotmerPreferencesList';


export default function CustomerDetailHeader({customer,customerDetails, request}: { customer: CustomerModel, customerDetails: CustomerModel, request: () => void }) {
  const [isDetailsExpanded, setIsDetailsExpanded] = React.useState(true)

  const getPhoneButtonLink = () => {
         return `tel:${get(customerDetails, 'phone')}`
  }
  return (
    <Card className={styles.leadDetailsHeaderCard}>
      <div className={styles.leadDetailsHeaderContainer}>
        <div className={styles.leadHeaderTop}>
          <div>
            <LeadName
              nameClassName={styles.leadHeaderName}
              avatarClassName={styles.leadHeaderAvatar}
              lead={customer}
            />
          </div>
          <div className={styles.leadHeaderActions}>
            <Space>
              {get(customer, 'customer.email') && (
                <a href={`mailto:${get(customer, 'customer.email')}`}>
                  <Button
                    size={'small'}
                    className={'button-secondary button-bordered'}
                    icon={<MailOutlined />}
                  >
                    <F
                      id={'common.attribute.email'}
                      defaultMessage={'Email'}
                    />
                  </Button>
                </a>
              )}
              {get(customerDetails, 'phone') && (
                <a href={getPhoneButtonLink()}>
                  <Button
                    size={'small'}
                    className={'button-secondary button-bordered'}
                    icon={<PhoneOutlined />}
                  >
                    <F id={'pages.lead.action.call'} defaultMessage={'Call'} />
                  </Button>
                </a>
              )}
            </Space>
          </div>
        </div>
        <div
          className={classNames(styles.leadHeaderBottom, {
            [styles.leadDetailsExpanded]: isDetailsExpanded,
          })}
        >
          {isDetailsExpanded && (
            <div>
              <div className={styles.leadPropertiesContainer}>
                <CustomerCardOrderedProperties
                  grid={{
                    sm: 8,
                    xs: 12,
                  }}
                  overrideVisibleProperties={
                    CUSTOMER_DETAILS_VISIBLE_PROPERTIES
                  }
                  lead={{ customer: {...customerDetails} }}
                  showFieldName
                  isTable
                  classes={{
                    fieldName: styles.leadDetailsFieldName,
                    fieldValue: styles.leadDetailsFieldValue,
                  }}
                  spaceSize={12}
                />
              </div>
              <CustomerPreferencesList
                leadDetails={{ customer: {...customerDetails} }}
                grid={{
                  sm: 8,
                  xs: 12,
                }}
              />
            </div>
          )}

          <Button
            className={styles.leadDetailsExpandButton}
            onClick={() => setIsDetailsExpanded((prev) => !prev)}
            size={'small'}
          >
            <F
              id={`pages.lead.drawer.view${
                isDetailsExpanded ? 'Less' : 'More'
              }`}
              defaultMessage={`View ${isDetailsExpanded ? 'Less' : 'More'}`}
            />
            {isDetailsExpanded ? (
              <UpOutlined style={{ paddingLeft: 5, fontSize: 10 }} />
            ) : (
              <DownOutlined style={{ paddingLeft: 5, fontSize: 10 }} />
            )}
          </Button>
        </div>
      </div>
    </Card>
  );
}
